import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-102">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald/5 rounded-full blur-[100px] pointer-events-none" data-id="element-103"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-104"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center gap-2 mb-8 px-4 py-2 border border-gold/30 rounded-full bg-gold/5" data-id="element-106">
          <Sparkles className="w-4 h-4 text-gold" data-id="element-107" />
          <span className="font-sans text-sm tracking-widest text-gold uppercase" data-id="element-108">
            El Secreto Revelado
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} viewport={{
        once: true
      }} className="font-serif text-4xl md:text-5xl text-cream mb-8 leading-tight" data-id="element-109">
          He desarrollado el <br data-id="element-110" />
          <span className="text-gold italic" data-id="element-111">Método del Lujo Accesible</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} viewport={{
        once: true
      }} className="font-sans text-lg text-cream-muted space-y-6 leading-relaxed" data-id="element-112">
          <p data-id="element-113">
            Es un sistema diseñado para identificar sustitutos inteligentes de
            supermercado que, al ser procesados con mi técnica de{' '}
            <strong className="text-cream font-semibold" data-id="element-114">
              "Tostado Ámbar"
            </strong>
            , igualan e incluso superan la textura de las pastelerías de los
            Emiratos.
          </p>
          <p className="text-xl text-cream font-medium border-l-2 border-emerald pl-6 py-2 text-left my-8" data-id="element-115">
            No necesitas importar nada; solo necesitas saber qué elegir y cómo
            ensamblarlo para mantener el "crunch" intacto por 48 horas.
          </p>
        </motion.div>
      </div>
    </section>;
}